/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import {
  Typography,
  Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Edit } from '@material-ui/icons';
import AsyncSelect from 'react-select/async';
import companyServices from '../../redux/services/companyServices';
import groupServices from '../../redux/services/groupServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';

const messages = defineMessages({
  newTeacher: {
    id: 'TableCustomer.newTeacher',
    defaultMessage: 'Create a new exam',
  },
  lastname: {
    id: 'TableCustomer.lastname',
    defaultMessage: 'Last Name',
  },
  language: {
    id: 'TableCustomer.language',
    defaultMessage: 'Language',
  },
  company: {
    id: 'TableCustomer.company',
    defaultMessage: 'Company',
  },
  phone: {
    id: 'TableCustomer.phone',
    defaultMessage: 'Phone',
  },
  begin: {
    id: 'TableCustomer.begin',
    defaultMessage: 'Beginning',
  },
  end: {
    id: 'TableCustomer.end',
    defaultMessage: 'End',
  },
  expiration: {
    id: 'TableCustomer.expiration',
    defaultMessage: 'Expiration',
  },
  city: {
    id: 'TableCustomer.city',
    defaultMessage: 'City',
  },
  duration: {
    id: 'TableCustomer.duration',
    defaultMessage: 'Duration',
  },
  update: {
    id: 'Button.update',
    defaultMessage: 'Update',
  },
  cancel: {
    id: 'Button.cancel',
    defaultMessage: 'Cancel',
  },
  addCompany: {
    id: 'TableCustomer.addClient',
    defaultMessage: 'Add Exam',
  },
  editCompany: {
    id: 'TableCustomer.editClient',
    defaultMessage: 'Edit Exam',
  },
  creationSuccess: {
    id: 'TableCustomer.popupSuccess',
    defaultMessage: 'Exam added successfully',
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  timePicker: {
    paddingLeft: '20px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  column: {
    flexBasis: '33.33%',
    marginLeft: 10,
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const files = [{ examFile: 'S3_EVALUATION_1', activityId: '5VZJfUrZLwn_course_id' },
  { examFile: 'S3_EVALUATION_2', activityId: '6j7BYCFq4hK_course_id' },
  { examFile: 'S3_EVALUATION_3', activityId: '6e1kAG6K7ci_course_id' },
  { examFile: 'S3_EVALUATION_4', activityId: '5zQfmfSKSqJ_course_id' },
  { examFile: 'S3_EVALUATION_5', activityId: '5cTmPafKDF8_course_id' },
  { examFile: 'S3_EVALUATION_6', activityId: '6IouyavFpv9_course_id' },
  { examFile: 'S2_RATTRAPAGE_EVALUATION_MOSELLE', activityId: '612p7wPj57y_course_id' }];

const noOptionsMessage = () => 'Type to search company...';

const EditExam = (props) => {
  const classes = useStyles();

  const [company, setCompany] = useState({ label: props.editExam.companyName, value: props.editExam.companyId });
  const [file, setFile] = useState(files[0]);
  const [group, setGroup] = useState([{ label: props.editExam.name, value: props.editExam.groupId }]);
  const [selectedDate, handleDateChange] = useState(props.editExam.examBegin);
  const [selectedEndDate, handleEndDateChange] = useState(props.editExam.examEnd);
  const [groups, setGroups] = useState([]);
  const { intl } = props;

  const editExam = () => {
    groupServices.getGroupById(props.editExam.groupId)
      .then((_res) => {
        const _elearningDetails = _res.elearning;

        _elearningDetails.exam = false;
        elearningDetailsServices.updateElearningDetails(_elearningDetails._id, _elearningDetails);

        group.forEach((_group) => {
          groupServices.getGroupById(_group.value)
            .then((res) => {
              const elearningDetails = res.elearning;
              elearningDetails.exam = true;
              elearningDetails.examType = 1;
              elearningDetails.examFile = file.examFile;
              elearningDetails.examActivityId = file.activityId;
              elearningDetails.examBegin = selectedDate;
              elearningDetails.examEnd = selectedEndDate;
              elearningDetailsServices.updateElearningDetails(elearningDetails._id, elearningDetails);
              props.setEditExam(null);
            })
            .catch((error) => {
              console.log(error);
            });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadOptions = (query, callback) => {
    if (query) {
      companyServices.searchCompanies(query)
        .then((data) => {
          const tempArray = [];
          data.company.forEach((element) => {
            tempArray.push({ label: `${element.name}`, value: element._id });
          });
          callback(tempArray);
        })
        .catch(() => { });
    } else {
      companyServices.getAllCompany()
        .then((data) => {
          const tempArray = [];
          data.forEach((element) => {
            tempArray.push({ label: `${element.name}`, value: element._id });
          });
          callback(tempArray);
        });
    }
  };

  const onSearchCompanyChange = (selected) => {
    if (selected) {
      setCompany(selected);
      groupServices.getAll(selected.value)
        .then((data) => {
          const tempArray = Object.keys(data).map((key) => ({
            label: data[key].name, value: data[key]._id,
          }));
          setGroup([]);
          setGroups(tempArray);
        });
    }
  };

  useEffectOnce(() => {
    groupServices.getAll(props.editExam.companyId)
      .then((data) => {
        const tempArray = Object.keys(data).map((key) => ({
          label: data[key].name, value: data[key]._id,
        }));
        setGroups(tempArray);
      });
    const tmpFile = files.find((file_) => file_.examFile === props.editExam.examFile);
    setFile(tmpFile);
  }, []);

  return (
    <Container className="group-creation-container-centered">
      <div className={classes.root}>
        <div className={classes.root}>
          <Row>
            <Col md={12}>
              <Button
                onClick={() => props.setEditExam(null)}
                style={{ width: 250, margin: 5, padding: '0.6em 0 0.6em 0' }}
                variant="outlined"
                color="primary"
              >
                {'< Back to exams'}
              </Button>
            </Col>
            <Col md={4}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                {intl.formatMessage(messages.company)}
              </Typography>
              <AsyncSelect
                value={company}
                placeholder="Type to search a company.."
                loadOptions={(query, callback) => loadOptions(query, callback)}
                cacheOptions
                defaultOptions
                onChange={(e) => { onSearchCompanyChange(e); }}
                noOptionsMessage={noOptionsMessage}
              />
            </Col>
            <Col md={4}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Group
              </Typography>
              <AsyncSelect
                value={group || ''}
                placeholder="Type to search a group.."
                isMulti
                defaultOptions={groups}
                isClearable
                onChange={(e) => {
                  setGroup(e);
                }}
              />
            </Col>
            <Col md={4}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Exam file
              </Typography>
              <AsyncSelect
                value={file}
                placeholder="Type to search a file.."
                defaultOptions={files}
                getOptionLabel={(option) => option.examFile}
                onChange={(e) => {
                  setFile(e);
                }}
              />
            </Col>
            <Col md={4} className={classes.timePicker}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                {intl.formatMessage(messages.begin)}
              </Typography>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </MuiPickersUtilsProvider>
            </Col>
            <Col md={4} className={classes.timePicker}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                {intl.formatMessage(messages.end)}
              </Typography>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  value={selectedEndDate}
                  onChange={handleEndDateChange}
                />
              </MuiPickersUtilsProvider>
            </Col>
            <Col md={4}>
              <Button
                onClick={() => editExam()}
                style={{ marginTop: '3.3em', padding: '1em 0 1em 0' }}
                variant="contained"
                color="primary"
                startIcon={<Edit />}
                fullWidth
              >
                { intl.formatMessage(messages.editCompany) }
              </Button>
            </Col>
          </Row>

        </div>
      </div>
    </Container>
  );
};

EditExam.propTypes = {
  intl: PropTypes.object.isRequired,
  editExam: PropTypes.object.isRequired,
  setEditExam: PropTypes.func.isRequired,
};

function mapState(state) {
  const { newCompany } = state.company;
  return { newCompany };
}

const connectedNewCompanyy = connect(mapState, null)(EditExam);

export default injectIntl(connectedNewCompanyy);
